//React & npms
import { Link }  from 'react-router-dom';
//MUI
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';

const Error404 = () => {
	return(
		<Container sx={{ position:'relative', height: '100vh' }} className="alignCenter">
			<div>
				<p className="font50 fontBold primaryCl mb20">Oops! Page Not Found</p>
				<p className="font30 mb20">It seems the page you&apos;re looking for has gone on a little adventure and is lost somewhere on the web. but don&apos;t worry, we&apos;ll help you get back on track!</p>
				<Link to={'/'}><Button size='large'>Home</Button></Link>
			</div>
		</Container>
	);
};

export default Error404;
